(function(module) {
    'use strict';

    function IntegrationsCtrl(utils, Integration, Includes, $state, ListModifier, Store, $mdDialog, App) {

        this.setDefault = () => {
            this.integrations = null;
            this.loading = true;
        };

        this.$onDestroy = () => {

        };

        this.getData = () => {
            return Integration
                .find({ filter: Includes.integrations })
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.integrations = Store.setMultiModelData('integrations', response);
                });
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onInit = () => {
            this.utils = utils;

            this.setDefault();
            this.getData();
        };

        this.goToIntegration = (integration) => {
            $state.go('root.integrations.edit-integration', {
                id: integration.id,
            });
        };

        this.findAppsWithIntegrationId = (integrationId) => {
            return App
                .find({
                    filter: {
                        where: { integrationId },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.delete = (id) => {
            this.findAppsWithIntegrationId(id).then((response) => {
                const appsUsingIntegrationCount = response && response.length;
                let modalTitle;
                let modalConfirmationText;
                let modalCancelText;
                let modalConfirmText;
                let confirmActionFunc;
                let itemCount1;

                if (appsUsingIntegrationCount > 0) {
                    modalTitle = 'You can\'t delete selected integration as it\'s used by:';

                    itemCount1 = appsUsingIntegrationCount > 0 ? `${appsUsingIntegrationCount + ' of your apps'}` : null;

                    modalConfirmationText = 'Please make sure this integration is not being used before deleting it.';
                    modalCancelText = 'Ok, I understand';
                } else {
                    modalTitle = 'Are you sure you want to permanently remove this integration?';
                    modalConfirmText = 'Yes, remove';
                    modalCancelText = 'Cancel';
                    confirmActionFunc = (id) => {
                        this.deleteById({ id });
                    };
                }

                $mdDialog.show({
                    locals: {
                        title: modalTitle,
                        confirmationText: modalConfirmationText,
                        cancelText: modalCancelText,
                        confirmText: modalConfirmText,
                        itemCount1: itemCount1,
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            $scope.cancel();

                            confirmActionFunc(id);
                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            });
        };

        this.deleteById = ({ id }) => {
            return Integration
                .deleteById({ id })
                .$promise
                .then(() => {
                    return Store.removeSingleModelData('integrations', id);
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

    }

    module
        .config(function($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider
                .state('root.integrations', {
                    url: '/integrations',
                    data: {
                        pageTitle: 'INTEGRATIONS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<integrations-list-component/>',
                        },
                    },
                    bodyClass: 'page--integrations',
                });

            $translatePartialLoaderProvider.addPart('/js/integrations');
        })
        .component('integrationsListComponent', {
            templateUrl: '/js/integrations/integrations.html',
            controller: IntegrationsCtrl,
        });

})(angular.module('rocket.components'));
